import axios from "axios";
import { Message } from "element-ui";
import { API_URL } from "@/lib/axios";
let api_url_real = API_URL;

// 创建axios实例
const service = axios.create({
  baseURL: api_url_real, // api的base_url
  timeout: 15000 // 请求超时时间,
});

// request拦截器
const APP_NAME = process.env.APP_NAME;
service.interceptors.request.use(
  config => {
    const AuthToken = localStorage.getItem("AUTH-TOKEN-K-ONE-CN");
    const AppCODE = window.__GTECH_VARIABLES_MAIN_APP_CODE__;
    config.headers["Auth-Token"] = AuthToken;
    config.headers["appCode"] = AppCODE;
    config.headers["appVersion"] = "2.2.1";
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

// respone拦截器
service.interceptors.response.use(
  response => {
    /**
     * code为非0是抛错 结合业务进行修改1
     */
    // console.log(response, '---in--axios')
    const res = response.data;
    if (response.headers['content-disposition']) {
      let name = response.headers['content-disposition'].replace("attachment;filename*=utf-8''", '');
      console.log(decodeURIComponent(name));

      return {
        data: res,
        name: name ? decodeURIComponent(name) : ''
      };
    }
    return {
      data: res
    };
  },
  error => {
    // 错误处理
    try {
      switch (error.response.status) {
        case 500:
          error.message = error.response.message || "服务器错误"; // 明确返回500
          break;
        case 404:
          error.message = error.response.message || "404"; // 明确返回404
          break;
        default:
          error.message = error.response.message || "其他错误"; // 其他错误code
      }
    } catch (e) {
      error.message = "链接超时"; // 超时 获取不到status
    }

    if (
      error.config &&
      error.config.options &&
      error.config.options.errorMessage
    ) {
      Message.error({
        message: error.message,
        offset: 11,
        duration: 2000
      });
    }
    return Promise.reject(error);
  }
);

export function httpServer(data
) {
  let {
    url,
    params,
    options = { errorMessage: true },
    method,
    responseType = 'blob'
  } = data;
  console.log(url, params);
  return service({
    url: url,
    method: method || "post",
    data: params,
    options: options,
    responseType
  });
}

